import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function AboutUs(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container}>
            <br/>
            <h2 className={classes.title}>A propos</h2>
            <p className={classes.description}>Créé par des ingénieurs passionnés, ChiNcoTec accompagne au Cameroun et dans le monde entier la stratégie de développement de ses clients dans les domaines de l’innovation et des systèmes d’information.</p>
            <p className={classes.description}>Nous oeuvrons au quotidien pour réaliser des produits utiles et fiables. Nous abordons constamment nos projets avec une grande humilité en remettant l’utilisateur au coeur des dispositifs que nous imaginons. Nous avons des principes et des engagements que nous respectons fermement.</p>
            <br/>
        </div>
        </div>

      <Footer />
    </div>
  );
}
